import { alpha, Box, useTheme } from "@mui/material";

const toneColor = (theme, tone) => {
  switch (tone) {
    case "success":
      return theme.palette.success.main;
    case "warning":
      return theme.palette.warning.main;
    case "error":
      return theme.palette.error.main;
    default:
      return theme.palette.extraColors.grey;
  }
};

export default function StatusChip({ children, icon, tone = "neutral" }) {
  const theme = useTheme();
  const color = toneColor(theme, tone);

  return (
    <Box
      component="span"
      className="d-inline-flex align-items-center"
      sx={{
        gap: "8px",
        width: "fit-content",
        padding: "4px 8px",
        border: "1px solid",
        borderColor: color,
        borderRadius: "100px",
        backgroundColor: alpha(color, 0.2),
        color: theme.palette.extraColors.black,
        fontSize: 12,
        lineHeight: 1.2,
      }}
    >
      {icon && (
        <Box component="span" className="d-flex align-items-center" sx={{ color }}>
          {icon}
        </Box>
      )}
      {children}
    </Box>
  );
}
